<template>
  <div class="d-flex flex-column h-100">
    <div class="mb-5">
      <h1>{{ error.message }}</h1>
      <p>
        Please  <a id="qsLogoutBtn" href="#" class @click.prevent="logout">Log out</a> and then contact your storeadmin for help.
      </p>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { MutationTypes } from "../store/mutations";
import { useStore } from 'vuex';
import { computed, inject } from 'vue';
import { errorContent } from '@/composables/useErrorLog';

const auth0 = useAuth0();
const store = useStore();
const posthog = inject("posthog");
const error = computed(() => { return errorContent.value != undefined ? JSON.parse(errorContent.value) : {message: 'This store is disabled'} });

const logout = () => {
  store.commit(MutationTypes.SET_INITIALLOGIN, false);
  const email = auth0.user.value.email;
  posthog.capture("logout_button_clicked", { email: email });
  sessionStorage.removeItem('vuex');
  localStorage.clear();
  auth0.logout({
    returnTo: window.location.origin
  });
}
</script>